var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.543 12.785c-.973 0-1.85.421-2.479 1.096l-7.171-3.503a3.953 3.953 0 0 0 0-.756l7.171-3.503a3.377 3.377 0 0 0 2.48 1.097C18.45 7.216 20 5.601 20 3.608S18.452 0 16.544 0c-1.91 0-3.457 1.615-3.457 3.608 0 .128.007.254.02.378L5.933 7.49a3.376 3.376 0 0 0-2.479-1.096C1.547 6.393 0 8.008 0 10c0 1.993 1.547 3.608 3.456 3.608.973 0 1.851-.422 2.48-1.097l7.17 3.503c-.011.124-.018.25-.018.378 0 1.993 1.546 3.608 3.456 3.608C18.452 20 20 18.385 20 16.392c0-1.992-1.549-3.607-3.457-3.607Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share.82edf79f1034b657132d720aa403addb.svg";